import { useEffect, useState } from 'react';
import { subscribe, dismissToast, type ToastItem } from '../../lib/toast';

const STYLES: Record<ToastItem['type'], { bg: string; icon: string }> = {
  success: { bg: 'bg-green-600', icon: 'ri-check-line' },
  error: { bg: 'bg-red-600', icon: 'ri-close-circle-line' },
  info: { bg: 'bg-babcock-navy-700', icon: 'ri-information-line' },
  warning: { bg: 'bg-amber-600', icon: 'ri-error-warning-line' },
};

/** Mounted once in App — renders the global toast stack (top-right). */
export default function ToastHost() {
  const [items, setItems] = useState<ToastItem[]>([]);

  useEffect(() => subscribe(setItems), []);

  if (items.length === 0) return null;

  return (
    <div className="fixed top-6 right-6 z-[100] flex flex-col gap-2">
      {items.map((t) => {
        const s = STYLES[t.type];
        return (
          <div
            key={t.id}
            role="alert"
            onClick={() => dismissToast(t.id)}
            className={`${s.bg} text-white px-5 py-3 rounded-lg shadow-lg flex items-center gap-2 text-sm font-medium cursor-pointer animate-in slide-in-from-top-2 fade-in duration-300 max-w-sm`}
          >
            <i className={s.icon}></i>
            <span>{t.message}</span>
          </div>
        );
      })}
    </div>
  );
}
